export const ALL = 'ALL';
export const COMPUTER_KEYBOARD = 'COMPUTER_KEYBOARD';
export const CUSTOM = 'CUSTOM';
